import { render, staticRenderFns } from "./BussinesStatusAdministrator.vue?vue&type=template&id=3fceb165&"
import script from "./bussines-status-administrator.ts?vue&type=script&lang=ts&"
export * from "./bussines-status-administrator.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports